import { Toolbar, Tooltip, MenuItem, IconButton } from '@material-ui/core'
import Text from './Text'
import Pill from './Pill'
import Select from './Select'
import Button from './Button'
import {
    KeyboardArrowLeftRounded,
    KeyboardArrowRightRounded,
} from "@material-ui/icons";
import _ from 'lodash'
import { versionTime } from '../utils/helpers'

export const WorkflowToolbar = ({ classes, workflowDisplayName, isModified, jsonErrors, taskErrors, jsonParseError, permissionConfig, workflowDef, selectedVersion, validSelectedVersion, workflowVersion, handleResetVersion, versions, handleOpenSave, toggleSplitPanel, workflowDefState }) => {

    const disableSaveButton = () => {
        return (
            !_.isEmpty(jsonErrors) ||
            !isModified ||
            !_.isEmpty(taskErrors) ||
            jsonParseError
        );
    };
    const disableResetButton = () => {
        return !isModified;
    };

    return (
        <Toolbar>
            <Text className={classes.workflowName}>
                {workflowDisplayName || "NEW"}
            </Text>
            {!_.isNull(isModified) &&
                (isModified ? (
                    <Pill color="yellow" label="Modified" />
                ) : (
                    <Pill color="neutral" label="Unmodified" />
                ))}
            {(!_.isEmpty(jsonErrors) ||
                !_.isEmpty(taskErrors) ||
                jsonParseError) && (
                    <Tooltip
                        disableFocusListener
                        title="There are validation or syntax errors. Validation errors at the root level may be seen by hovering over the opening brace."
                    >
                        <Pill color="red" label="Validation" />
                    </Tooltip>
                )}



            {permissionConfig?.canCreateWorkflow ? (
                <div className={classes.rightButtons}>
                    <div>
                        <Select
                            className={classes.verSelect}
                            disabled={!workflowDef}
                            // value={_.isUndefined(workflowVersion) ? "" : workflowVersion}
                            value={
                                _.isUndefined(selectedVersion) ||
                                    validSelectedVersion === false
                                    ? ""
                                    : workflowVersion
                            }
                            displayEmpty
                            renderValue={(v) =>
                                v === "" ? "Latest Version" : `Version ${v}`
                            }
                            onChange={(evt) => {
                                handleResetVersion(evt.target.value);
                            }}
                        >
                            <MenuItem value="">
                                Latest Version - Version{" "}
                                {versions && versions.length > 0 ? versions[0] : 0}
                            </MenuItem>
                            {versions && versions.length > 0
                                ? versions
                                    .sort((a, b) => b.version - a.version)
                                    .map((row) => {
                                        const version = row.version ? row.version : row;
                                        const versionTimeValue = versionTime(version);

                                        return (
                                            <MenuItem value={row} key={version}>
                                                Version {version}{" "}
                                                {versionTimeValue ? `(${versionTimeValue})` : ""}
                                            </MenuItem>
                                        );
                                    })
                                : null}
                        </Select>
                    </div>
                    <Button
                        disabled={disableSaveButton()}
                        onClick={handleOpenSave}
                        variant="contained"
                        color="primary"
                    >
                        Save
                    </Button>

                    <Button
                        onClick={() => handleResetVersion(workflowVersion)}
                        variant="outlined"
                        color="primary"
                        disabled={disableResetButton()}
                    >
                        Reset
                    </Button>

                    <IconButton
                        onClick={() => {
                            toggleSplitPanel();
                        }}
                    >
                        {workflowDefState.toggleGraphPanel && (
                            <KeyboardArrowRightRounded />
                        )}
                        {!workflowDefState.toggleGraphPanel && (
                            <KeyboardArrowLeftRounded />
                        )}
                    </IconButton>
                </div>
            ) : (
                <div className={classes.rightButtons}>
                    <IconButton
                        onClick={() => {
                            toggleSplitPanel();
                        }}
                    >
                        {workflowDefState.toggleGraphPanel && (
                            <KeyboardArrowRightRounded />
                        )}
                        {!workflowDefState.toggleGraphPanel && (
                            <KeyboardArrowLeftRounded />
                        )}
                    </IconButton>
                </div>
            )}
        </Toolbar>
    )
}
